import React, { useState, useEffect } from 'react';
import axios from 'axios';



// function App() {
//     const [allData, setAllData] = useState([]);
//     const [filteredData, setFilteredData] = useState(allData)

//     const handleSearch = (event) => {
//         let value = event.target.value.toLowerCase();
//         let result = [];
//         result = allData.filter((data) => {
//             console.log(data.title.search(value))
//             // console.log(data.title)
//             // console.log(data.images.large)
//             return data.title.search(value) > -1;
//         });
//         setFilteredData(result);
//     }

//     useEffect(() => {
//         axios('https://api.fbi.gov/wanted/v1/list')
//             .then(response => {
//                 console.log(response.data.items);
                
//                 // console.log(response.data.total);
//                 // console.log(response.data.items);
                
//                 setAllData(response.data.items);
//                 setFilteredData(response.data.items);
//             })
//             .catch(error => {
//                 console.log('Error getting fake data: ' + error);
//             });
//     }, []);




//     const styles = {
//         display: 'inline',
//         width: '30%',
//         height: 50,
//         float: 'left',
//         padding: 5,
//         border: '0.5px solid black',
//         marginBottom: 10,
//         marginRight: 10
//     }




//     return (
//         <div className="App">
// <div style={{ margin: '0 auto', marginTop: '10%' }}>
// <label>Search:</label>
// <input type="text" onChange={(event) =>handleSearch(event)} />
// </div>

// <div style={{padding:10}}>
// {filteredData.map((value,index)=>{
//         console.log(value.images[0].large)

// return(
// <div key={index}>
// <div style={styles}>
// {value.title}  {value.caution} <img src={value.images[0].large} alt="…"></img>
// </div>
// </div>
// )
// })}
// </div>
// </div>
//     )}

import List from './Components/List'; 
// import Info from './Components/Info'; 
// import Aliases from './Components/Aliases';
// import Alias from './Components/Alias'

function App() {
    const [contacts, setContacts] = useState([])
    const [search, setSearch] = useState('')
    const [loading, setLoading] = useState(false);
    const [count, setCount] = useState(1);




    useEffect(() => {
        const getData = async () => {
        const API_URL = `https://api.fbi.gov/wanted/v1/list?page=${count}`
        await axios.get(API_URL, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET',
                        'Content-Type': 'application/json',
                        'X-Content-Type-Options': 'nosniff'
        }})
            .then(res => {
                console.log(res.status)

                let img = res.request.responseURL
                console.log(`img: ${img}`)
                const contacts = res.data.items
                setContacts(contacts)
            })
              .catch(function (error) {
                  if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                  } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request);
                  } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                  }
              })
                 .finally(() => {
                     setLoading(false);
                     console.log('finally')
                 })
                }
                getData()
    }, [count])

              if (loading) {
              return <p> Data is loading... </p>;
          }


//.catch(error => console.error(`Error: ${console.error;}`))


    const filteredContacts = search.length === 0 ? contacts : 
    contacts.filter(contact => contact.title.toLowerCase().includes(search.toLowerCase()))



//   const Button = ({ className, children }) => {
//   const [activated, setActivated] = React.useState(false);
//   return (
//     <button
//       className={`button ${className}`}
//       aria-pressed={activated ? "true" : "false"}
//       onClick={() => setActivated(!activated)}>
//       {children}
//     </button>
//   )
// }

    // function toggle() {
    //     let p = document.querySelector('small')
    //     let classes = p.classList;
    //     console.log(classes)
    //     classes.toggle('read-more');
    //     if (p.classList.contains('read-more-visible')) {
    //         p.classList.remove('read-more-visible')
    //     } else {
    //         p.classList.add('read-more-visible')
    //     }
    // }

    return (
        <>
        <div className="bg">
            <nav className='sticky'>
            <h4>Fbi Most Wanted. <span className='blue'>page: {count}</span></h4>
            <input
                type="text"
                placeholder="Search name"
                value={search}
                onChange={(e) => setSearch(e.target.value)} />
                <button onClick={() => setCount(count + 1)}>
                    next
                </button>
                {/* <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg">
  <circle cx="52" cy="27" r="2" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" strokeWidth="2"/>
  <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" strokeWidth="2" d="m10.129 54-2.948 2.948M7.181 54l2.948 2.948"/>
  <circle cx="53" cy="10" r="1"/>
  <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" strokeWidth="2" d="M34 54.423V62M22 62v-7.577"/>
  <path d="M43 34h1.071a4.027 4.027 0 0 1 4.029 4.028 4.027 4.027 0 0 1-4.028 4.028H43" fill="none" stroke="#000" stroke-linejoin="round" strokeWidth="2"/>
  <path d="M12.749 42.056h-.721A4.027 4.027 0 0 1 8 38.028h0A4.027 4.027 0 0 1 12.028 34h.843M43 30.551V40.9A14.1 14.1 0 0 1 28.9 55h-1.8A14.1 14.1 0 0 1 13 40.9V30.527" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" strokeWidth="2"/>
  <path d="M21.933 37.213a2.814 2.814 0 0 1-4.342.032M37.933 37.213a2.814 2.814 0 0 1-4.342.032M26 4.689V3a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v1.636M29.933 44.213a2.814 2.814 0 0 1-4.342.032M14 26a4 4 0 0 0-4 4h7.614a6.811 6.811 0 0 0 6.2 4h8.37a6.811 6.811 0 0 0 6.2-4H46a4 4 0 0 0-4-4ZM43 26v-9A12 12 0 0 0 31 5h-6a12 12 0 0 0-12 12v9" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" strokeWidth="2"/>
  <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" strokeWidth="2" d="M31 14.243 32.243 13 31 11.757V10h-1.757L28 8.757 26.757 10H25v1.757L23.757 13 25 14.243V16h1.757L28 17.243 29.243 16H31v-1.757z"/>
  <path fill="none" stroke="#000" stroke-linejoin="round" strokeWidth="2" d="M43 21H13"/>
</svg> */}

<svg width="64" height="64" xmlns="http://www.w3.org/2000/svg">
  <circle cx="52" cy="27" r="2" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
  <path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m10.1 54-2.9 2.9m0-2.9 2.9 2.9"/>
  <circle cx="53" cy="10" r="1"/>
  <path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M34 54.4V62m-12 0v-7.6"/>
  <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth="2" d="M43 34h1.1c2.2 0 4 1.8 4 4s-1.8 4-4 4H43"/>
  <path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12.7 42.1H12c-2.2 0-4-1.8-4-4 0 0 0 0 0 0h0c0-2.2 1.8-4 4-4 0 0 0 0 0 0h.8M43 30.6v10.3C43 48.7 36.7 55 28.9 55h-1.8C19.3 55 13 48.7 13 40.9V30.5"/>
  <path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21.9 37.2c-1 1.2-2.8 1.4-4 .4-.1-.1-.3-.2-.4-.4m20.4 0c-1 1.2-2.8 1.4-4 .4-.1-.1-.3-.2-.4-.4M26 4.7V3c0-1.1.9-2 2-2h0c1.1 0 2 .9 2 2v1.6m-.1 39.6c-1 1.2-2.8 1.4-4 .4-.1-.1-.3-.2-.4-.4M14 26c-2.2 0-4 1.8-4 4h7.6c1.1 2.4 3.5 4 6.2 4h8.4c2.7 0 5.1-1.6 6.2-4H46c0-2.2-1.8-4-4-4H14zm29 0v-9c0-6.6-5.4-12-12-12h-6c-6.6 0-12 5.4-12 12v9"/>
  <path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m31 14.2 1.2-1.2-1.2-1.2V10h-1.8L28 8.8 26.8 10H25v1.8L23.8 13l1.2 1.2V16h1.8l1.2 1.2 1.2-1.2H31z"/>
  <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth="2" d="M43 21H13"/>
</svg>

                </nav>
            <List contacts={filteredContacts} />
        </div>
        {/* <div className="grid">
            <Info contacts={contacts} />
        </div> */}
            </>
    )
}

export default App;
